<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:<span v-if="required" class="text-red-500">*</span></label>
    <input :id="id" v-mask="mask" ref="input" v-bind="{ ...$attrs, class: null }" class="form-input" :class="{ error: error }" :type="type" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" @blur="clearIncompletedField()" />
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import {mask, TheMask} from 'vue-the-mask'

export default {
  inheritAttrs: false,
  components: {
    TheMask,
  },
  directives: {
    mask
  },
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    error: String,
    label: String,
    required: String,
    modelValue: [String, Number],
    mask: [Array, String],
    clearIncomplete: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
    clearIncompletedField() {
      if(this.clearIncomplete) {
        if(typeof(this.mask) == "string") {
          if (this.modelValue.length < this.mask.length) {
            this.$emit('update:modelValue', '');
          }
        } else if(typeof(this.mask) == "object") {
          let clear = true;
          for(let mask_index in this.mask) {
            let mask = this.mask[mask_index];
            if (typeof(this.modelValue) != 'undefined' && this.modelValue.length == mask.length) {
              clear = false;
            }
          }
          if (clear) {
            this.$emit('update:modelValue', '');
          }
        }
      }
    },
  },
}
</script>
